export { ConnectPage as default, getStaticProps } from 'modules/home/pages/ConnectPage'
